import RoleForm from '../components/RoleForm'
import { createRole } from '../reducers/actions'

const NewRole = () => {
	return <RoleForm submitAction={createRole} title='New role' />
}

export default NewRole
